export type DispatchedAction = { meta?: { requestStatus?: string }; payload?: unknown };

// createController actions resolve with the (possibly rejected) action instead
// of throwing, so a failed write reads as success to useForm/ConfirmDialog.
// Throwing here re-arms that machinery (surface the error, keep the form open).
export function unwrapAction<T = unknown>(
  result: unknown,
  fallbackMessage = 'Something went wrong. Please try again.',
): T {
  const action = result as DispatchedAction;
  if (action?.meta?.requestStatus === 'fulfilled') {
    return action.payload as T;
  }

  const payload = action?.payload;
  if (payload && typeof payload === 'object' && 'errors' in payload) {
    const errors = (payload as { errors?: Array<{ message?: string }> }).errors;
    if (Array.isArray(errors) && errors[0]?.message) {
      throw new Error(errors[0].message);
    }
  }
  throw new Error(fallbackMessage);
}
